import { motion } from "framer-motion";
import { Smartphone, Infinity as InfinityIcon, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const Tile = ({ className = "", children, testid, delay = 0 }) => (
  <Reveal delay={delay} className={className}>
    <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.4 }} data-testid={testid} className="relative h-full overflow-hidden rounded-[28px]">
      {children}
    </motion.div>
  </Reveal>
);

const PhotoTile = ({ img, title, text }) => (
  <>
    <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120]/85 via-[#0B1120]/30 to-transparent" />
    <div className="relative h-full flex flex-col justify-end p-7 sm:p-9 text-white">
      <h3 className="font-display text-2xl sm:text-3xl font-medium max-w-md">{title}</h3>
      <p className="mt-2 text-slate-200 max-w-md">{text}</p>
    </div>
  </>
);

const IconTile = ({ Icon, title, text, dark }) => (
  <div className={`h-full p-7 sm:p-9 flex flex-col ${dark ? "bg-[#0B1120] text-white" : "bg-[#A8DCF2] text-[#0B1120]"}`}>
    <Icon className="w-7 h-7" strokeWidth={1.5} />
    <h3 className="mt-auto pt-10 font-display text-2xl sm:text-3xl font-medium">{title}</h3>
    <p className={`mt-2 ${dark ? "text-slate-300" : "text-[#0B1120]/75"}`}>{text}</p>
  </div>
);

export const Benefits = () => (
  <section id="beneficii" data-testid="benefits-section" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36">
    <Reveal>
      <Eyebrow>De ce EasyREW.</Eyebrow>
      <h2 className="mt-5 max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.02] tracking-[-0.02em]">
        Recenziile vin <span className="italic font-black text-[#5FB4E2]">când</span> clientul e încă zâmbitor.
      </h2>
    </Reveal>
    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 md:auto-rows-[300px] gap-4">
      <Tile className="md:col-span-8 min-h-[320px] md:min-h-0" testid="bento-moment" delay={0}>
        <PhotoTile img="/img/cafe.jpg" title="Prinzi momentul potrivit" text="Cererea de recenzie apare chiar la tejghea, nu într-un e-mail uitat a doua zi." />
      </Tile>
      <Tile className="md:col-span-4 min-h-[260px] md:min-h-0" testid="bento-no-subscription" delay={0.08}>
        <IconTile Icon={InfinityIcon} title="Plătești o singură dată" text="Fără abonament, fără comisioane per recenzie." />
      </Tile>
      <Tile className="md:col-span-4 min-h-[260px] md:min-h-0" testid="bento-no-app" delay={0.12}>
        <IconTile dark Icon={Smartphone} title="Fără aplicații" text="NFC pe iPhone și Android, plus cod QR de rezervă." />
      </Tile>
      <Tile className="md:col-span-8 min-h-[320px] md:min-h-0" testid="bento-local" delay={0.16}>
        <PhotoTile img="/img/barber.jpg" title="Mai vizibil în Google Maps" text="Mai multe recenzii recente îți fac profilul mai convingător pentru clienții din zonă." />
      </Tile>
    </div>
    <Reveal className="mt-10 flex items-center gap-3 text-sm text-[#475569]">
      <MapPin className="w-4 h-4" /> Pentru cafenele, restaurante, saloane, frizerii, magazine și orice afacere locală.
    </Reveal>
  </section>
);
